import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWarehouse$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWarehouse extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '37568bb6a6308e6cdeb028f60ff83063ecc388b6', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fc1ce9846edc8d86a87cbafe50d77dd888c9686b', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'f31e2d648fce6a0c38ffdb276a8f8be2620bee82', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 6.287V16.5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V5.586a.5.5 0 0 1 .323-.474L10.3 2.3a.6.6 0 0 1 .4 0l7.977 2.812a.5.5 0 0 1 .323.474V9.5a.5.5 0 0 1-.5.5H18a.5.5 0 0 1-.5-.5V6.287l-7-2.47zm4 3.213a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm-.5 5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm5-5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5zm-.5 5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5zm5-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-warehouse", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-warehouse"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-warehouse":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWarehouse$1);
            }
            break;
    } });
}

const CosmosIconWarehouse = CosmosIconWarehouse$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWarehouse, defineCustomElement };
